import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Chip,
  Stack,
} from "@mui/material";

export default function SpreadAcrossAccounts({ userData, onSelectionChange }) {
  const accounts = userData?.accounts ?? [];
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [spreadAll, setSpreadAll] = useState(false);

  const handleSpreadAllChange = (event) => {
    const checked = event.target.checked;
    setSpreadAll(checked);
    const updated = checked ? [...accounts] : [];
    setSelectedAccounts(updated);
    onSelectionChange?.(updated);
  };

  const handleAccountToggle = (account) => {
    setSelectedAccounts((prev) => {
      const isSelected = prev.includes(account);
      const updated = isSelected
        ? prev.filter((a) => a !== account)
        : [...prev, account];

      setSpreadAll(updated.length === accounts.length);
      onSelectionChange?.(updated);
      return updated;
    });
  };

  useEffect(() => {
    if (selectedAccounts.length === accounts.length && accounts.length > 0) {
      setSpreadAll(true);
    } else {
      setSpreadAll(false);
    }
  }, [accounts.length, selectedAccounts.length]);

  if (accounts.length === 0) return null;

  return (
    <Box my={2}>
      <FormControlLabel
        control={
          <Checkbox
            checked={spreadAll}
            onChange={handleSpreadAllChange}
            sx={{
              color: "#1976d2",
              "&.Mui-checked": { color: "#1976d2" },
              "&:hover": { backgroundColor: "rgba(25, 118, 210, 0.04)" },
            }}
          />
        }
        label={
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Spread this campaign across all the associated accounts
          </Typography>
        }
      />

      <Box mt={1.5} ml={4}>
        <Typography
          variant="subtitle2"
          color="text.secondary"
          sx={{ mb: 1, fontWeight: 500 }}
        >
          Select Accounts:
        </Typography>

        <Stack direction="row" flexWrap="wrap" gap={1}>
          {accounts.map((acc) => (
            <Chip
              key={acc}
              label={acc}
              onClick={() => handleAccountToggle(acc)}
              variant={selectedAccounts.includes(acc) ? "filled" : "outlined"}
              sx={{
                borderRadius: "12px",
                fontSize: "0.875rem",
                fontWeight: 500,
                borderColor: "#1976d2",
                color: selectedAccounts.includes(acc) ? "#fff" : "#1976d2",
                backgroundColor: selectedAccounts.includes(acc)
                  ? "#1976d2"
                  : "transparent",
                "&:hover": {
                  backgroundColor: selectedAccounts.includes(acc)
                    ? "#1565c0"
                    : "rgba(25,118,210,0.08)",
                },
                cursor: "pointer",
              }}
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
}
